
import { MoveRight } from 'lucide-react';
// @ts-ignore
import { AnimatePresence, motion } from 'framer-motion';
import GoogleIcon from 'media/svgs/google.svg?react';
import { ChangeEvent } from 'react';
import { cn } from 'utils/cn';
import Button, { buttonVariants } from '../Button';
import Checkbox from '../Checkbox';
import { Input } from '../Input';
import Label from '../Label';
import SignupCompanyDetails from './signup-company-details';

export type SignUpFormProps = {
    // loginUser: (event: any) => void;
    handleChangeEmail: (event: ChangeEvent<HTMLInputElement>) => void;
    handleChangeName: (event: ChangeEvent<HTMLInputElement>) => void;
    handleGotoLogin: () => void;
    handleStartTrial: () => void;
    isRegisterPending: boolean;
    isTrialPending: boolean;
    email: string;
    name: string;
    teamSize: string;
    source: string;
    companyName: string;
    setTeamSize: (value: string) => void;
    setSource: (value: string) => void;
    handleChangeCompanyName: (event: any) => void;
    registrationStepTwo: boolean;
    userData: any;
    comingFromMainSite: any
    SignupOption: string;
    agreeToUserPrivacy: boolean;
    setAgreeToUserPrivacy: (value: boolean) => void;
    registerUser: (event: any) => void;
    handleGoogleRegister: (event: any) => void;
    collabMode?: boolean;
    itemDetails?: any;
};

const SignupForm = ({
    handleChangeEmail,
    handleChangeCompanyName,
    handleChangeName,
    handleGotoLogin,
    handleStartTrial,
    isRegisterPending,
    isTrialPending,
    email,
    name,
    teamSize,
    source,
    companyName,
    setTeamSize,
    setSource,
    registrationStepTwo,
    userData,
    comingFromMainSite,
    SignupOption,
    agreeToUserPrivacy,
    setAgreeToUserPrivacy,
    registerUser,
    handleGoogleRegister,
    collabMode,
    itemDetails,
}: SignUpFormProps) => {

    return (
        <>
            {!registrationStepTwo && !userData ? (
                <div
                    id="atarim-signup"
                    className="mt-4 flex flex-col gap-6"
                >
                    <div className="flex flex-col gap-2">
                        <div className='px-1 flex flex-col gap-2'>
                            <>
                                <>
                                    <Label className="flex items-center">
                                        Email Address{' '}
                                    </Label>
                                    <Input
                                        value={email}
                                        placeholder="Your Work Email Address *"
                                        onChange={
                                            handleChangeEmail
                                        }
                                    />
                                    <AnimatePresence>
                                        {email.trim() !== '' && (
                                            <>
                                                <motion.div
                                                    initial={{ opacity: 0, height: '0' }}
                                                    animate={{ opacity: 1, height: 'auto' }}
                                                    exit={{ opacity: 0, height: '0' }}
                                                    className=" overflow-hidden">

                                                    <div className="mt-4 flex flex-col gap-2">
                                                        <Label className="flex items-center">
                                                            Full Name (Optional)
                                                        </Label>
                                                        <Input
                                                            value={name}
                                                            placeholder="Your Full Name"
                                                            onChange={handleChangeName}
                                                        />
                                                    </div>

                                                    <div className="col-span-2 mx-0 mt-4 flex items-center justify-start gap-2">
                                                        <Checkbox
                                                            checked={agreeToUserPrivacy}
                                                            onCheckedChange={setAgreeToUserPrivacy}
                                                            className=""
                                                            name="internal-checkbox"
                                                        />
                                                        <Label
                                                            htmlFor="internal-checkbox"
                                                            className="cursor-pointer font-normal"
                                                            onClick={() =>
                                                                setAgreeToUserPrivacy(
                                                                    (!agreeToUserPrivacy)
                                                                )
                                                            }
                                                        >
                                                            I agree to the{' '}
                                                            <a
                                                                className={cn(
                                                                    buttonVariants({
                                                                        variant: 'link',
                                                                        size: 'sm',
                                                                    }),
                                                                    'h-5 px-0 font-medium'
                                                                )}
                                                                href={`https://atarim.io/terms-and-conditions/`}
                                                                target="__blank"
                                                            >
                                                                terms &amp; conditions
                                                            </a>
                                                        </Label>
                                                    </div>
                                                </motion.div>
                                            </>
                                        )}
                                    </AnimatePresence>
                                </>
                            </>
                        </div>

                    </div>
                    <div className="flex flex-col px-1">
                        {/* {SignupOption === 'regular' ? ( */}
                        <Button
                            disabled={!agreeToUserPrivacy}
                            onClick={registerUser}
                            loading={isRegisterPending}
                            size="sm"
                            rightIcon={<MoveRight size={18} />}
                            className="mb-4 w-full text-sm"
                        >
                            Start Collaborating
                        </Button>
                        <Button
                            onClick={(e) => {
                                handleGoogleRegister(e);
                            }}
                            variant="outline"
                            className="w-full text-sm"
                            size="sm"
                            leftIcon={<GoogleIcon width={18} height={18} />}
                        >
                            Sign Up with Google
                        </Button>

                        <Button
                            variant="link"
                            size="link"
                            className="mt-4 flex w-fit self-center px-0 text-textcolor"
                            onClick={() => {
                                handleGotoLogin()
                            }}
                        >
                            I already have an account (Login)
                        </Button>

                    </div>
                </div>
            ) : (
                <SignupCompanyDetails
                    companyName={companyName}
                    handleChangeCompanyName={handleChangeCompanyName}
                    handleStartTrial={handleStartTrial}
                    isTrialPending={isTrialPending}
                    teamSize={teamSize}
                    setTeamSize={setTeamSize}
                    source={source}
                    setSource={setSource}
                />
            )}
        </>
    );
};

export default SignupForm;